"use client";
import React from "react";
import { useState } from "react";
import Loginslider from "../../Components/Loginslider";
import { handleApiCall } from "../../apis";
import { endpoint } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import state from "sweetalert/typings/modules/state";
const ResetPassword = () => {
    const Navigate = useNavigate()
    const location = useLocation()
    const { state } = location
    const [eError, setEError] = useState(false);
    const [email, setEmail] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [passError, setPassError] = useState("")
    const [cpassError, setCPassError] = useState("")
    const [loading, setLoading] = useState(false)
    const [Signupdata, setSignUpdata] = useState({

        password: "",
        confirm: "",
    });
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name == 'password') {
            const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

            // Check the password validity against the regex
            if (!regex.test(value)) {
                setPassError("Password must have at least 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character, and be at least 8 characters long.");
            } else {
                setPassError("");  // Clear error message if valid
            }
        }
        if (name == 'confirm') {


            // Check the password validity against the regex
            if (value.trim() !== value.trim()) {
                setCPassError("Password not matched.");
            } else {
                setCPassError("");  // Clear error message if valid
            }
        }
        setSignUpdata((prev) => ({
            ...prev,
            [name]: value
        }));

    };
    const handleReset = async (e) => {
        e.preventDefault()
        //    if(eError.length !==0){
        //      return;
        //    }
        // navigate("/");
        setLoading(true)
        try {

            const response = await handleApiCall("post", `${endpoint.resetPassword}`, {
                "email": state?.email,
                "newPassword": Signupdata.password,
                "confirmPassword": Signupdata.confirm
            });
            if (response?.data?.code === 200) {
                toast.success(response?.data?.message)
                Navigate('/login')
                //  Navigate('/otpverification',{state:{email:email,type:'forgotPassword'}})
            } else {
                toast.error(response?.response?.data?.errorMessage)
            }

        } catch (error) {
            console.error("Error:", error);

        } finally {
            setLoading(false)
        }

    }

    return (
        <>
            <div className="w-full md:flex block">
                <div className="lg:w-6/12 w-full leftSlider" >
                    {/* <Link to="/" className="text-subhead cursor-pointer px-4 py-2 inline-block">
                        <img src="/images/home.png" alt="" className="h-8 w-8 ml-2" />
                    </Link> */}
                    <div className="flex items-center justify-center h-screen">
                        <div className="block md:w-80 w-10/12 space-y-1">
                            <img src="/images/black-logo.svg" alt="" className="mx-auto" />
                            <div>
                                <h1 className="text-2xl text-black text-center py-2 font-BonaNovaRegular">Reset Password</h1>
                                <form action="#" method="POST" className="" onSubmit={handleReset}>


                                    <div className="mb-4 relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            placeholder="Password"
                                            required
                                            value={Signupdata.password}
                                            onChange={(e) => {
                                                handleInputChange(e)
                                            }}
                                            className="mt-1 w-full px-3 py-2 border border-inputfieldborder pr-10 bg-white outline-none text-13 font-Montserratmedium text-forgetpassword"
                                        //   onInvalid={(e) => e.target.setCustomValidity('Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character (@, $, !, %, *, ?, &), and be at least 8 characters long.')}
                                        />



                                        {/* Eye Icon for Toggle */}
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                            className="absolute right-3 top-6 transform -translate-y-1/2 text-subhead"
                                        >
                                            {showPassword ? (
                                                // Eye Closed (Password Hidden)
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-5 h-5">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.25 12s3.75-6 9.75-6 9.75 6 9.75 6-3.75 6-9.75 6-9.75-6-9.75-6z" />
                                                </svg>
                                            ) : (
                                                // Eye visible (Password show)
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-5 h-5">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12s3.75-6 9.75-6 9.75 6 9.75 6-3.75 6-9.75 6S3 12 3 12z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.5 4.5l-15 15" />
                                                </svg>
                                            )}
                                        </button>
                                        {passError && <p className="text-red-500 text-xs mt-1">{passError}</p>}
                                    </div>
                                    <div className="mb-4 relative">
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            name="confirm"
                                            placeholder="Confirm Password"
                                            required
                                            value={Signupdata.confirm}
                                            onChange={handleInputChange}
                                            className="mt-1 w-full px-3 py-2 border border-inputfieldborder pr-10 bg-white outline-none text-13 font-Montserratmedium text-forgetpassword"
                                        />

                                        {/* Eye Icon for Toggle */}
                                        <button
                                            type="button"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            className="absolute right-3 top-6 transform -translate-y-1/2 text-subhead"
                                        >
                                            {showConfirmPassword ? (
                                                // Eye Closed (Password Hidden)
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-5 h-5">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.25 12s3.75-6 9.75-6 9.75 6 9.75 6-3.75 6-9.75 6-9.75-6-9.75-6z" />
                                                </svg>
                                            ) : (
                                                // Eye visible (Password show)
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-5 h-5">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12s3.75-6 9.75-6 9.75 6 9.75 6-3.75 6-9.75 6S3 12 3 12z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.5 4.5l-15 15" />
                                                </svg>
                                            )}
                                        </button>
                                        {cpassError && <p className="text-red-500 text-xs mt-1">{cpassError}</p>}
                                    </div>


                                    <button type="submit" disabled={loading}
                                        className="my-2 px-8 py-2 bg-buttonbg text-13 text-white focus:outline-none font-Montserratmedium w-full">
                                        Reset Password
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="lg:w-6/12 w-full hidden lg:block rightAuth">
                    <Loginslider />
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
